// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor-antd","vendor-rc","vendor-markdown","vendor-others","vendor-react","vendor-eslint","vendor-react-icons","dict-app","vendor-docviewer","vendor-aggrid","vendor-agcharts","vendor-jodit"], () => (__webpack_require__("./clientside/js/CSR/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
